module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_vm._v("Texts and Translations")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The commentary is based on the New International Version of the Bible (NIV) 2011. The text of this version is quoted at the beginning of every commentary section, with paragraphing and spacing kept intact. All quotations from the English Bible are also from the NIV, unless otherwise indicated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Quotations from the Greek New Testament are from the "), _c('em', [_vm._v("Novum Testamentum Graece")]), _vm._v(" (Nestle-Aland, 28th ed.), and quotations from the Hebrew/Aramaic Old Testament are from "), _c('em', [_vm._v("Biblica Hebraica Stuttgartensia")]), _vm._v(". Quotations of the Apocrypha are taken from NRSV; of the Pseudepigrapha from "), _c('em', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(" (2 vols., ed. J. H. Charlesworth [Garden City, NY: Doubleday, 1983, 1985]); of the Dead Sea Scrolls from "), _c('em', [_vm._v("The Dead Sea Scrolls Reader")]), _vm._v(" (6 vols., ed. D. W. Parry and E. Tov [Leiden: Brill, 2004–2005]); and of Philo from the Loeb Classical Library.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a0015e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Texts.vue
// module id = 84
// module chunks = 0